export default __webpack_public_path__ + "static/media/abstract-white.8c59b56e.png";